var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIntroDisabled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.096 22.8H5.302c-.687 0-1.247-.582-1.247-1.298V2.497c0-.715.56-1.297 1.247-1.297h12.794c.688 0 1.247.582 1.247 1.297v19.005c0 .716-.56 1.297-1.247 1.297zm.416-19.042c0-.896-.727-1.623-1.623-1.623H6.509c-.896 0-1.623.727-1.623 1.623v16.554c0 .896.727 1.623 1.623 1.623h10.38c.896 0 1.623-.727 1.623-1.623V3.758zM11.699 19.34a.425.425 0 00-.415.433c0 .238.186.432.415.432.23 0 .416-.194.416-.432a.425.425 0 00-.416-.433zm-.831-16.41h1.662c.23 0 .416.193.416.432a.424.424 0 01-.416.432h-1.662a.424.424 0 01-.416-.432c0-.239.186-.432.416-.432z",
    fill: "#C6C6C8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.307 7.434c-.33.198-.53.567-.53.966V15c0 .4.201.77.531.967a.996.996 0 001.074-.03l4.896-3.3c.303-.206.484-.559.484-.937s-.181-.73-.484-.935l-4.894-3.3a.992.992 0 00-1.077-.03zm.601.781l4.897 3.302c.055.037.09.106.09.183a.221.221 0 01-.09.184l-4.896 3.3a.154.154 0 01-.167.005.217.217 0 01-.099-.188V8.4c0-.082.04-.154.1-.19a.15.15 0 01.165.005z",
    fill: "#C6C6C8"
  })));
}
export default SvgIntroDisabled;